module.exports = __webpack_public_path__ + "static/mindef-e0e9fa84aece3eb16bcb8f1632075dd4.jpg";